import { GridCol, GridContainer, GridRow, Icon, ICONS, StackIntoView } from '@bob/library'
import { Markdown } from '@websrc/App/Components/Markdown/Markdown'
import { getAnchorPropsFromLink } from '@websrc/App/Helpers/getAnchorPropsFromLink'
import { spotWrapperProps } from '@websrc/App/Helpers/spotWrapperProps'
import { useLocale } from '@websrc/App/Hooks/useLocale'
import { mapTextRowsSpot } from '@websrc/DataMappers/mapSpot'
import React from 'react'

import * as SC from './SpotTextRows.style'

export interface SpotTextRowsProps {
  spot: ReturnType<typeof mapTextRowsSpot>['text_rows']
}

export function SpotTextRows({ spot }: SpotTextRowsProps) {
  const { rows } = spot
  const locale = useLocale()

  return (
    <GridContainer {...spotWrapperProps(spot.caption)}>
      <GridRow justifyContent={'center'}>
        <GridCol desktop={8}>
          <StackIntoView stackGrandChildren={true}>
            {rows.map(({ cta_link, description, headline }, i) => {
              const anchorProps = getAnchorPropsFromLink(cta_link, locale)

              return (
                <SC.StyledRow key={i}>
                  <GridCol tablet={5}>
                    <SC.Header>{headline}</SC.Header>
                  </GridCol>
                  <GridCol tablet={7}>
                    {description && (
                      <SC.Description>
                        <Markdown markdown={description} />
                      </SC.Description>
                    )}

                    {anchorProps.href && (
                      <SC.ButtonTertiary data-testid={'link'} {...anchorProps}>
                        <Icon icon={ICONS.ARROW_RIGHT} size={16} />
                        <span>{cta_link.cta_text}</span>
                      </SC.ButtonTertiary>
                    )}
                  </GridCol>
                </SC.StyledRow>
              )
            })}
          </StackIntoView>
        </GridCol>
      </GridRow>
    </GridContainer>
  )
}
